module.exports = __webpack_public_path__ + "static/media/四足机器人-02-PNG.1d1d9038.png";